/**
 * Permission slugs for bulk import/export actions.
 * Keep in sync with backend checkPermission() on routes and permissionSeeds.js.
 */

export const IMPORT_ENTITY_PERMISSION = {
  institutes: "institute.create",
  departments: "department.import",
  courses: "course.import",
  classes: "class.import",
  teachers: "teacher.import",
  subjects: "subject.import",
  students: "student.profile.create",
  users: "user.import",
  superadmins: "user.import",
  hod: "user.import",
  admin: "user.import",
};

export const EXPORT_ENTITY_PERMISSION = {
  institutes: "institute.export",
  departments: "department.export",
  courses: "course.export",
  classes: "class.export",
  teachers: "teacher.export",
  subjects: "subject.export",
  students: "user.export",
  users: "user.export",
};

/** All distinct import permission slugs (for global Import page / menu). */
export const ALL_IMPORT_PERMISSION_SLUGS = [
  ...new Set(Object.values(IMPORT_ENTITY_PERMISSION)),
];

export function getImportPermission(entityType) {
  if (!entityType) return null;
  return IMPORT_ENTITY_PERMISSION[String(entityType).toLowerCase()] ?? null;
}

export function getExportPermission(entityType) {
  if (!entityType) return null;
  return EXPORT_ENTITY_PERMISSION[String(entityType).toLowerCase()] ?? null;
}

/**
 * Import/export UI: user holds the slug and the permission's module is enabled (or modules not loaded).
 */
export function canUseImportExportPermission(enabledModules, permissions, slug) {
  if (!slug || !Array.isArray(permissions) || !permissions.includes(slug)) return false;
  if (enabledModules == null) return true;
  const mod = String(slug).split(".")[0];
  if (!mod) return true;
  if (!Array.isArray(enabledModules) || enabledModules.length === 0) return true;
  return enabledModules.some((m) => String(m || "").toLowerCase() === mod.toLowerCase());
}
